import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod"
import {TextureType} from "@generated"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            angleInDegrees: z.number(),
            textureType: z.nativeEnum(TextureType),
        }),
    },
}
